import React from 'react';
import { Link } from 'react-router-dom';
import defaultClasses from '../../../searchResults.module.css';

var StoreItemActions = function StoreItemActions(_ref) {
  var store = _ref.store,
      calculateRoute = _ref.calculateRoute,
      coordinates = _ref.coordinates,
      predefinedCoordinates = _ref.predefinedCoordinates,
      onGetDirection = _ref.onGetDirection;
  return React.createElement("div", {
    className: "".concat(defaultClasses.storeItemActions)
  }, React.createElement("div", {
    className: "".concat(defaultClasses.directionsContent)
  }, store.website && React.createElement("a", {
    className: "uppercase",
    href: "https://".concat(store.website),
    target: "_blank",
    rel: "noopener"
  }, "Website"), React.createElement("a", {
    href: calculateRoute(coordinates.lat, coordinates.lng, store.street, store.city, store.state, store.zip),
    className: "uppercase",
    target: "_blank",
    rel: "noopener",
    onClick: function onClick(e) {
      onGetDirection(store.lng, store.lat);

      if (!predefinedCoordinates.lat || !predefinedCoordinates.lng) {// showStoreLocatorModal();
        // alert('show modal');
      }
    }
  }, "Get directions")));
};

export default StoreItemActions; //lightworksofsteamboat.com/